const directiveName = 'ltValidateDateOfBirth';
const directive = [() => {

	const birthDatePattern = /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/;

	function isValid(modelValue: string, required: boolean): boolean {
		return birthDatePattern.test(modelValue) || !required;
	}

	return {
		require: 'ngModel',
		link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attr: ng.IAttributes, ctrl: ng.INgModelController) => {

			ctrl.$validators.dateOfBirth = (modelValue: string, viewValue: string) => {
				const required = attr.required != null;

				return isValid(modelValue, required);
			};

		}
	} as ng.IDirective<ng.IScope, ng.IAugmentedJQuery, ng.IAttributes, ng.INgModelController>;
}];

export default function(module: ng.IModule): void {
	module.directive(directiveName, directive);
}
